import React, { useState, useEffect } from 'react';
import { Form, Popover, Col, Row, ProgressBar, Modal, Alert } from 'react-bootstrap';
import { Segment } from "semantic-ui-react";
import { Amplify, Storage, API, Auth } from 'aws-amplify';
import { TextField } from '@material-ui/core';
import { message, Upload, Space, Button, notification, Alert as AAlert } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import NavBar from './NavBar'
import '../App.css';
import { useHistory, Link } from "react-router-dom";


export default function Home() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	let history = useHistory();

	//Post Params
	const [username, setUsername] = useState();

	const [sequence, setSequence] = useState("");
	const [sequenceName, setSequenceName] = useState();
	const [path, setPath] = useState("");
	const [progress, setProgress] = useState(0);
	const [length, setLength] = useState();

	const [queues, setQueues] = useState(0);
	const [display_queue, setDisplay_queue] = useState("none");



	// const [identity, setIdentity] = useState(40);
	const [sequenceCount, setSequenceCount] = useState(0);

	//Seqence Check
	const [sequenceError, setSequenceError] = useState(false);

	const [file, setFile] = useState();
	const [fileCheck, setFileCheck] = useState();

	const [FileName, setFileName] = useState();

	// disable
	const [disable1, setDisable1] = useState(false);
	const [disable2, setDisable2] = useState(false);
	const [disable_submit, setDisable_submit] = useState(true);
	const [uploaded, setUploaded] = useState(false);

	// Modal
	const [uploadTitile, setUploadTitile] = useState("Uploading...");
	const [show_upload, setShow_upload] = useState(false);
	const [show_success, setShow_success] = useState(false);
	const [show_uploaded, setShow_uploaded] = useState(false);
	const [show_error, setShow_error] = useState(false);
	const [errorInfo, setErrorInfo] = useState("");
	const handleClose_upload = () => setShow_upload(false);

	const Bucket = "s3://alphafold2-prod/public/";
	var Path;
	// var time;

	const Sequence_eg = ">p0001\nARNDCQEGHILKMFPSTWYVNX";

	function simulateNetworkRequest() {
		return new Promise((resolve) => setTimeout(resolve, 100000));
	}

	const [isLoading, setLoading] = useState(false);

	function getUserInfo() {
		Auth.currentAuthenticatedUser({
			bypassCache: false
		}).then(
			user => {
				console.log(user)
				setUsername(user.attributes.email);
			}
		)
			.catch(err => console.log(err));
	}

	useEffect(() => {
		getUserInfo();
	}, [])


	useEffect(() => {
		if (isLoading) {
			simulateNetworkRequest().then(() => {
				setLoading(false);
			});
		}
	}, [isLoading]);

	function checkSequence(props) {
		let arr_1 = props.replaceAll("\n", "&@%$\n").split("\n");
		// console.log(arr_1);
		var count_sequence = 0;
		var count_error = 0;
		let currentArr0 = arr_1[0];
		if (props === "" || props === null || props === undefined) {
			setDisable_submit(true);
			setSequenceError(false);
		} else if (props.startsWith(">") && currentArr0.replaceAll("&@%$", "").split(">")[1].split(/[^\w_]/g)[0] !== "" && arr_1[1] !== undefined && arr_1[1] !== "") {
			setSequenceError(false);
			let current = arr_1[0].replaceAll("&@%$", "").split(">")[1].split(/[^\w_]/g)[0];
			setSequenceName(current);
			for (let i = 1; i < arr_1.length; i++) {
				if (arr_1[i].replaceAll("&@%$", "").match(/[^ARNDCQEGHILKMFPSTWYVNX]/g)) {
					// console.log("Error Type");
					setDisable_submit(true);
					setSequenceError(true);
					count_error++;
				}

			}
			if (count_error === 0) {
				setSequenceCount(count_sequence);
				setDisable_submit(false);
			}

		} else {
			setDisable_submit(true);
			setSequenceError(true);
		}

	}

	function handleSequence(e) {
		let currentSequence = e.target.value;

		if (currentSequence === "") {
			setDisable2(false);
			// setDisable(true);
			setSequenceError(false);
		} else {
			setDisable2(true);
			// setDisable(false);
			checkSequence(currentSequence);
		}
		setSequence(currentSequence);
	}

	function checkFile(params) {
		const current = params;

		let arr_1 = current.replaceAll("\n", "&@%$\n").split("\n");
		console.log(arr_1);
		var count_sequence = 0;
		var count_error = 0;
		if (current === "" || current === null || current === undefined) {
			setDisable_submit(true);
			// setSequenceError(false);
		} else if (current.startsWith(">") && arr_1[1] !== undefined && arr_1[1] !== "") {
			// setSequenceError(false);
			for (let i = 1; i < arr_1.length; i++) {
				if (arr_1[i].replaceAll("&@%$", "").match(/[^ARNDCQEGHILKMFPSTWYVNX]/g)) {
					// console.log("Error Type");
					setDisable_submit(true);
					count_error++;
					setFileCheck(false);
					// console.log(arr_1[i],"Error item");

				}
			}

			if (count_error === 0) {
				// console.log("Sequence Amount:", count_sequence);
				setSequenceCount(count_sequence);
				setFileCheck(true);
			}

		} else {
			setDisable_submit(true);
			setFileCheck(false);
		}
	}

	useEffect(() => {
		if (username !== undefined && username !== "") {
			setDisable1(false);
			setDisable2(false);
		} else {
			setDisable1(true);
			setDisable2(true);
		}
	}, [username])

	useEffect(() => {
		if (fileCheck !== undefined) {
			if (fileCheck === true) {
				let ts = new Date().getTime();
				let filename = ts + "/" + file.name;
				setShow_upload(true);
				Storage.put(filename, file, {
					progressCallback(progress) {
						var percentage = (progress.loaded / progress.total * 100).toFixed(1);
						setProgress(percentage);
						console.log(percentage);
					}
				})
					.then(result => {
						// console.log(result);
						Path = Bucket + filename;
						console.log(Path);
						setPath(Path);
						setUploadTitile("Success");
						setShow_uploaded(true);
						setDisable_submit(false);
						setTimeout(
							() => {
								// setShow_upload(false);
								handleSubmit();
							},
							3000
						);
					})
					.catch(err => {
						console.log(err);
						setShow_error(true);
					});
			} else {
				message.error('File ERROR!');
			}
		}
	}, [fileCheck])

	const props = {
		name: 'file',
		showUploadList: false,
		beforeUpload: (file) => {
			var reader = new FileReader();
			reader.readAsText(file);
			reader.onload = function () {
				let currentString = file.name.split(".");
				if (currentString[0] !== "") {
					setDisable1(true);
					setFileCheck();
					setSequence("");

					setFile(file);
					setSequenceName(file.name);
					setFileName(file.name);
					checkFile(this.result)

					let current = this.result.split("\n");
					let count = 0;
					for (let i = 1; i < current.length; i++) {
						count += current[i].length;
					}
					setLength(count);
				} else {
					message.error('No File Name!');
				}

			}

		},
	};


	function Jump2Results() {
		setTimeout(
			() => {
				window.location.href = "/results";
			},
			3000
		);
	}


	useEffect(() => {
		if (uploaded === true) {
			let ts = new Date();
			let currentDate = ts.format("yyyyMMdd");
			let uid = "alphafold2-" + currentDate + "-" + ts.valueOf();

			async function postSeptember() {
				Amplify.Logger.LOG_LEVEL = "DEBUG";

				// const session = await Auth.currentCredentials();
				const session = await Auth.currentSession();
				console.log(session)
				const apiRequest = {
					body: {
						"Username": username,
						"Length": length,
						"Timestamp": ts.valueOf(),
						"ID": uid,
						"Sequence_s3_path": path

					},
					headers: {
						"Content-Type": "application/json",
						"Authorization":  session.getIdToken().getJwtToken()

					},
				};

				return await API
					.post("AlphaFold2", "/alphafold2", apiRequest)
					.then(
						(data) => {
							console.log(data);
							// saveParams(uid,current);
							setShow_success(true);
							Jump2Results();
						},
						(error) => {
							console.log(error);
						}
					);
			};
			postSeptember();
			let currentPOST = {
				"Username": username,
				"Length": length,
				"Timestamp": ts.valueOf(),
				"ID": uid,
				"Sequence_s3_path": path
			};
			console.log("POST:", currentPOST);
		}

	}, [uploaded])



	function handleSubmit() {
		setLoading(true);
		if (disable1 === false) {
			handleTest();

		} else {
			setUploaded(true);
		}


	}

	function handleTest() {
		const blob = new Blob([sequence], { type: "text/plain" });
		// let fname = Date.parse(new Date()) + '.aa';

		let current = sequence.split("\n");
		let count = 0;
		for (let i = 1; i < current.length; i++) {
			count += current[i].length;
		}
		setLength(count);

		let ts = new Date().getTime();
		let fname = ts + "/" + sequenceName + '.fasta';
		// console.log();
		if (sequenceError === false && disable_submit === false) {
			Storage.put(fname, blob, {
				progressCallback(progress) {
					var percentage = (progress.loaded / progress.total * 100).toFixed(1);
					// setProgress(percentage);
					console.log(percentage);
				}
			})
				.then(result => {
					Path = Bucket + fname;
					console.log(Path);
					setPath(Path);
					setUploaded(true);
					// setUploadTitile("Checking");
					// FileCheck(Path);
				})
				.catch(err => console.log(err));
		}
		return Path;
	}

	// useEffect(() => {
	// 	getQueue();
	// }, [])

	async function getQueue() {
		// Amplify.Logger.LOG_LEVEL = "DEBUG";
		// const session = await Auth.currentCredentials();
		const session = await Auth.currentSession();
		// console.log(session)
		const apiRequest = {
			headers: {
				"Content-Type": "application/json",
				// "Authorization":  session.getIdToken().getJwtToken()
			},
		};

		return await API
			.get("AlphaFold2", "/queue", apiRequest)
			.then(
				(data) => {
					// console.log(processQueue(data.Items));
					let current = processQueue(data.Items);
					setQueues(processQueue(data.Items))
					setDisplay_queue("block")

					if (current === 1) {
						notification['warning']({
							message: 'Notification',
							description: 'There is ' + current + ' task in queue, if you want to submit a new task please wait patiently for the result.',
							duration: 10,
						});

					} else if (current > 1) {
						notification['warning']({
							message: 'Notification',
							description: 'There are ' + current + ' tasks in queue, if you want to submit a new task please wait patiently for the result.',
							duration: 10,
						});
					}


				},
				(error) => {
					console.log(error);

				}
			);
	};

	function processQueue(params) {
		let count = 0;
		for (let i = 0; i < params.length; i++) {
			if (params[i].Status === "Queued") {
				count++;
			}
		}
		return count;
	}

	return (
		<div className="MyAll">
			<AAlert
				message={<h3>Notice: The AlphaFold2 TIB Server will not support compute service, please use <a href="https://sideways-fowl-fee.notion.site/d5748d969d054deeb8118e6f86226aeb?v=ab363dbc85904294b62434034a249e77" target='_blank' rel='noopener noreferrer'><b>TaiHang HPC service</b></a>.</h3>}
				type="warning"
				closable
				// onClose={onClose}
			/>
			<div className="MyNav">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<NavBar />

						<Segment basic >
							<h1 style={{ textAlign: "center", color: "white" }}><i>AlphaFold2 TIB Server</i></h1>
							<Segment basic>
								<h3 style={{ color: "white", textAlign: "justify" }}>AlphaFold v2.0 is a completely new model that was entered in CASP14 and published in Nature.It is widely regarded as a breakthrough milestone in predicting 3D structures of proteins using a Deep Neural Network approach. For simplicity, we refer to this model as AlphaFold throughout the rest of this document.</h3>
								<h3 style={{ color: "white", textAlign: "justify" }}>AlphaFold source code is publicly available earlier this month.  According to the official document, Alphafold was tested on Google Cloud with a machine using the nvidia-gpu-cloud-imagewith 12 vCPUs, 85 GB of RAM, a 100 GB boot disk, the databases on an additional 3 TB disk, and an A100 GPU. </h3>
								<h3 style={{ color: "white", textAlign: "justify" }}>After trying for quick a bit of time, we found that it is not easy to setup an enviorment to run AlphaFold. For example, downloading the data takes a loooooong time. To make the AlphaFold easy to use for TIB researchers, we have developed a serverless web platform for running AlphaFold.</h3>
							</Segment>
						</Segment>
					</Col>
					<Col></Col>
				</Row>
			</div>
			{/* <div style={{height:"2em"}} /> */}
			<div className="MyBody">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<Segment basic>
							<Form>
								<Segment secondary style={{ textAlign: "center", opacity: "0.7" }}>


									<div style={{ height: "1rem" }} />

									<Segment basic>
										<TextField
											error={sequenceError}
											id="outlined-multiline-static"
											label="Sequence(FASTA format)"
											multiline
											rows={6}
											fullWidth="true"
											// style={{width:"100%"}}
											placeholder="The AlphaFold2 TIB Server will not support compute service, please use TaiHang HPC service."
											helperText={
												"Only single protein is accepted and the length should not exceed 1000aa.  If you have large protein or many proteins to fold, please contact Biodesign center."
											}
											variant="outlined"
											onChange={handleSequence}
											// onBlur={handleTest}
											disabled={true}
										/>
									</Segment>

									<Segment basic>
										<Space>
											<Upload {...props}>
												<Button icon={<UploadOutlined />} disabled={true} >{FileName === undefined ? "Click to Upload" : FileName}</Button>
											</Upload>

											<Button
												variant="primary"
												disabled={true}
												onClick={!isLoading ? handleSubmit : null}
											>
												{isLoading ? 'Submitting…' : 'Submit'}
											</Button>

											<Button variant="primary" href="https://alphafold2-prod.s3.amazonaws.com/result/102/result.zip" target="_blank">Example Output</Button>
										</Space>
									</Segment>
								</Segment>

							</Form>
						</Segment>
						<div style={{ height: "20px" }} />
					</Col>
					<Col></Col>
				</Row>
			</div>

			<div>
				<div>
					<Modal
						size="lg"
						show={show_upload}
						onHide={handleClose_upload}
						backdrop="static"
						keyboard={false}
					>
						<Modal.Header closeButton>
							<Modal.Title>{uploadTitile}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<>
								<Alert show={show_uploaded} variant="success" onClose={() => setShow_uploaded(false)} dismissible>
									<Alert.Heading>Success</Alert.Heading>
									<p>After 3 seconds the task will be automatically Submitted...</p>
								</Alert>
								<Alert show={show_error} variant="danger" onClose={() => setShow_error(false)} dismissible>
									<Alert.Heading>Error</Alert.Heading>
									<p style={{ wordBreak: "break-all" }}>{errorInfo}</p>
								</Alert>
								<ProgressBar variant="success" now={progress} label={`${progress}%`} />
							</>
						</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={handleClose_upload}>
								Close
							</Button>

						</Modal.Footer>
					</Modal>

					
					
				</div>

			</div>

		</div>
	)
}
